module.exports = __webpack_public_path__ + "img/趋势预测ico.3578c4f2.png";